// Modules
import React, { useContext, useState } from "react";
import PropTypes from "prop-types";

// Context
import ApiContext from "../../../contexts/ApiContext";

// Assets
import "./flip-image.scss";
import TouchAppIcon from "@material-ui/icons/TouchApp";

const FlipImage = (props) => {
  const {
    clssName,
    srcFront,
    srcBack,
    roomName,
    est_termine,
  } = props;
  const { isMobile, isTablet } = useContext(ApiContext);
  const [flipImage, setFlipImage] = useState(false);

  return (
    <React.Fragment>
      {isMobile === false && isTablet === false
        ? (
          <div className={`flip-box-container ${clssName}`}>
            <div className="flip-box-inner">
              <div className="flip-box-front">
                <div
                  className="image-front"
                  style={{ backgroundImage: `url(${srcFront})` }}
                  title={`${roomName} avant travaux`}
                />
                <p className="before-working">Avant travaux</p>
              </div>
              <div className="flip-box-back">
                <div
                  className="image-back"
                  style={{ backgroundImage: `url(${srcBack})` }}
                  title={`Exemple ${roomName} après travaux`}
                />
                <p className="after-working">
                  {est_termine === true
                    ? "Après travaux"
                    : "Exemple après travaux"}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={`image-box-container ${clssName}`}
            onClick={() => setFlipImage(!flipImage)}
            style={{
              marginTop: "3.5vh",
              height: "25vh",
              width: "100%",
              backgroundColor: "transparent",
              position: "relative",
            }}
          >
            <div className={`front ${flipImage === true ? "hide" : "show"}`}>
              <TouchAppIcon className="flip-icon" />
              <div
                className="image-front"
                style={{ backgroundImage: `url(${srcFront})` }}
                title={`${roomName} avant travaux`}
              />
              <p className="before-working">Avant travaux</p>
            </div>
            <div className={`back ${flipImage === true ? "show" : "hide"}`}>
              <TouchAppIcon className="flip-icon" />
              <div
                className="image-back"
                style={{ backgroundImage: `url(${srcBack})` }}
                title={`${roomName} après travaux`}
              />
              <p className="after-working">
                {est_termine === true
                  ? "Après travaux"
                  : "Exemple après travaux"}
              </p>
            </div>
          </div>
        )
      }
    </React.Fragment >
  );
};

FlipImage.propTypes = {
  clssName: PropTypes.string,
  srcFront: PropTypes.string.isRequired,
  srcBack: PropTypes.string.isRequired,
  roomName: PropTypes.string.isRequired,
  est_termine: PropTypes.bool.isRequired,
};

FlipImage.defaultProps = {
  clssName: "",
};

export default FlipImage;
